import { ToggleButtonGroup, ToggleButton } from "@mui/material"
import { useTranslation } from "react-i18next"
import { styled } from "@mui/material/styles"

const StyledToggleButtonGroup = styled(ToggleButtonGroup)(({ theme }) => ({
  background: "linear-gradient(to right, #2196f3, #ffffff)",
  borderRadius: "20px",
  overflow: "hidden",
  boxShadow: "0px 1px 3px rgba(0, 0, 0, 0.2)",
  border: "none",
  height: "32px",
}))

const StyledToggleButton = styled(ToggleButton)(({ theme }) => ({
  fontSize: "0.75rem",
  minWidth: 40,
  padding: "4px 10px",
  color: "#1976d2",
  fontWeight: 500,
  backgroundColor: "transparent",
  "&.Mui-selected": {
    backgroundColor: "#1976d2",
    color: "#ffffff",
  },
  "&:hover": {
    backgroundColor: "rgba(255,255,255,0.2)",
  },
  transition: "all 0.3s ease",
}))

const LanguageToggle = () => {
  const { i18n } = useTranslation()

  const handleChange = (_, newLang) => {
    if (newLang && newLang !== i18n.language) {
      i18n.changeLanguage(newLang)
    }
  }

  return (
    <StyledToggleButtonGroup value={i18n.language} exclusive onChange={handleChange} size='small'>
      <StyledToggleButton value='en'>EN</StyledToggleButton>
      <StyledToggleButton value='he'>HE</StyledToggleButton>
    </StyledToggleButtonGroup>
  )
}

export default LanguageToggle
